<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            show-checkbox
            :filter-node-method="filterNode"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
        <el-button size="mini" @click="createDiscountTicket" >创建优惠券</el-button>
        <el-button size="mini"  plain @click="sj" >上架</el-button>
        <el-button size="mini"  plain @click="xj" >下架</el-button>
        <canvas  id="canvas" hidden/>
        <el-table height="600px" :data="discountTickets" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="250">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-evenly">
                <el-link type="primary" @click="showDialog(scope.row)">编辑</el-link>
                <el-link type="primary" @click="createQRCode(scope.row)">生成二维码</el-link>
                <el-link type="primary" @click="showQRCodeDialog(scope.row)">查看二维码</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="优惠券名称" width="200">
          </el-table-column>
          <el-table-column
            align="center"
            prop="ticketTypeName"
            label="优惠券类型" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="面额" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="fullMoney"
            label="满金额" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="subMoney"
            label="减金额" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rate"
            label="折扣率" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="单品名称" width="200">
          </el-table-column>
          <el-table-column
            align="center"
            prop="validDate"
            label="有效期" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sendNum"
            label="已发放张数" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalNum"
            label="总张数" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            label="二维码" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.qrcodeImgUrl" :src="scope.row.qrcodeImgUrl" width="50px" height="50px">
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createName"
            label="创建人" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间" width="150">
          </el-table-column>
        </el-table>
        <div style="margin-top: 3px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="ticketCurrentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="ticketPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ticketPageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="编辑优惠卡"
      :visible.sync="editDialog"
      width="40%"
      style="position: absolute"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <p>总次数：</p>
      <el-input v-model="editDiscountTicket.totalNum"
                size="mini" style="width: 200px;"></el-input>
      <p>有效期：</p>
      <el-date-picker
        v-model="editDiscountTicket.validDate"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        size="mini">
      </el-date-picker>
      <p>适用门店：</p>
      <div style="margin-left: 10px;margin-top: 10px">
        <span style="font-size: 14px">可适用门店:</span>
        <el-link type="primary">已选择{{selectedShops.length}}家适用门店</el-link>
        <el-button size="mini" @click="showShopDialog">选择门店</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeDialog">取 消</el-button>
            <el-button size="mini" @click="editDiscountTicketMethod">确 定</el-button>
          </span>
    </el-dialog>

    <el-dialog
      title="选择适用门店"
      :visible.sync="shopVisible"
      width="50%"
      @close="closeShopDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style=" height: 400px;display: flex;justify-items: center;justify-content: center">
        <el-transfer
          filterable ref="shopTransfer"
          :filter-method="filterMethod"
          filter-placeholder="请输入门店名称"
          style="height: 400px;" size="mini" :props="{key:'id', label:'orgName'}"
          v-model="selectedShops" :titles="['待选择门店','已选择门店']"
          :right-default-checked="selectedShops"
          :button-texts="['移除', '添加']"
          :data="shopList" @change="handleChange" clearQuery>
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeShopDialog">取 消</el-button>
        <el-button size="mini" @click="selectionShop">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="二维码"
      :visible.sync="qrcodeVisible"
      width="350px"
      @close="closeQRCodeDialog"
      :close-on-click-modal="false"
    >
      <img :src="showQRImage" height="300px" width="300px"/>
    </el-dialog>
  </div>
</template>

<script>
import { Button } from 'element-ui';

import QRCode from 'qrcode';

export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgList:[],
      discountTickets:[],
      selectedDiscountTicketList:[],
      ticketCurrentPage: 1,
      ticketPageSize:20,
      ticketPageTotal:0,
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      baseRequest:{
        pageNum:1,
        pageSize:20,
        shopId:''
      },
      shopDiscountTicket:{
        shopIds:[],
        ticketInfos:[],
        creator:'',
      },
      editDialog:false,
      editDiscountTicket:'',
      shopVisible:false,
      qrcodeVisible:false,
      selectedShops:[],
      shops:[],
      shopList:[],
      useShopIds:[],
      qrImage:'',
      showQRImage:'',
    }
  },
  methods:{
    showQRCodeDialog(row){
      this.showQRImage = row.qrcodeImgUrl
      this.qrcodeVisible = true;
    },
    closeQRCodeDialog(){
      this.qrcodeVisible = false;
    },
    createQRCode(row){
      let canvas = document.getElementById('canvas')
      canvas.innerHTML='';
      QRCode.toCanvas(canvas, `${row.id}`,{ width:200,
        height:200,
        correctLevel: 'M'}
      )
      var dataUrl = canvas.toDataURL('image/jpeg');
      let blob = this.dataUrlToBlob(dataUrl);
      this.uploadQRCode(blob, row)
      //  QRCode.toDataURL(
      //   `${row.id}`,
      //   {
      //   width:200,
      //   height:200,
      //   correctLevel: 'M'
      //  }).then((url) =>{
      //   this.qrImage = url
      //   var image = QRCode.toDataURL('image/jpeg')


      //   const {data:res} = this.$http.post(`/save/ticket/qrcodeImg`, {id:row.id, qrcodeImgUrl:url});
      //   if(res.code == 200){
      //     this.$message.success("操作成功！")
      //   }
      //  }).catch((err) => {
      //     console.log(err)
      //  })
    },
    dataUrlToBlob(dataUrl){
      let arr = dataUrl.split(",")
      let mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: 'text/plain;charset=utf-8'
      })
    },
    uploadQRCode(blob, row){
      let data = new FormData();
      data.append('file', blob, 'qrcode.txt');
      const {data:res} = this.$http.post(`/upload/qrcode`, data, {
        headers:{
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.$http.post(`/save/ticket/qrcodeImg`, {id:row.id, qrcodeImgUrl:res.data.data.url})
        .then(res1 => {
          console.log(res1)
          if(res1.data.code == 200){
            this.loadDiscountTicketList();
          }
        });
      });
    },
    showDialog(row){
      this.editDiscountTicket = row;
      this.loadShops();
      this.loadUseShop(row.id);
      this.editDialog = true;
    },
    closeDialog(){
      this.editDialog = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadDiscountTicketList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.baseRequest.pageNum = val;
      this.loadDiscountTicketList();
    },
    async loadShops(){
      this.baseRequest.shopId = this.shopId;
      this.baseRequest.orgLevel = this.orgLevel;
      this.shopList = [];
      this.selectedShops = [];
      const {data:res} = await this.$http.post(`/load/shops`, this.baseRequest)
      this.shopList = res.data;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.shopId}`);
      this.orgList = [res.data];
    },
    createDiscountTicket(){
      this.$router.push("/createDiscountTicket");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    handleSelectionChange(val){
      this.selectedDiscountTicketList = val;
    },
    async sj(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.shopDiscountTicket.shopIds = this.$refs.tree.getCheckedKeys();
      this.shopDiscountTicket.ticketInfos = this.selectedDiscountTicketList;
      this.shopDiscountTicket.creator = this.userId;
      const {data:res} = await this.$http.post(`/sj/ticket`, this.shopDiscountTicket);
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.error("操作失败！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
    },
    async xj(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.shopDiscountTicket.shopIds = this.$refs.tree.getCheckedKeys();
      this.shopDiscountTicket.ticketInfos = this.selectedDiscountTicketList;
      this.shopDiscountTicket.creator = this.userId;
      const {data:res} = await this.$http.post(`/xj/ticket`, this.shopDiscountTicket);
      if (res.code === 200){
        this.$message.success("操作成功！")
        const {data:res} = await this.$http.post(`/sj/ticket`, this.shopDiscountTicket);
      } else {
        this.$message.error("操作失败！")
        const {data:res} = await this.$http.post(`/sj/ticket`, this.shopDiscountTicket);
      }
    },
    loadDiscountTicket(){
      this.loadDiscountTicketCount();
      this.loadDiscountTicketList();
    },
    async loadDiscountTicketCount(){
      const {data:res} = await this.$http.post(`/load/ticket/count`, this.baseRequest);
      this.ticketPageTotal = res.totalPage;
    },
    async loadDiscountTicketList(){
      const {data:res} = await this.$http.post(`/load/ticket/list`, this.baseRequest);
      this.discountTickets = res.data;
    },
    async editDiscountTicketMethod(){
      this.editDiscountTicket.shopIds = this.selectedShops;
      const {data:res} = await this.$http.post(`/edit/ticket`, this.editDiscountTicket);
      if(res.code == 200){
        this.$message.success("操作成功！")
      }
      this.loadDiscountTicket();
      this.closeDialog();
    },
    showShopDialog(){
      this.shopVisible = true;
    },
    closeShopDialog(){
      this.shopVisible = false;
    },
    filterMethod(query, item){
      return item.orgName.indexOf(query) > -1;
    },
    selectionShop(){
      this.closeShopDialog();
    },
    handleChange(value, direction, movedKeys){
      this.selectedShops = value;
    },
    async loadUseShop(id){
      const {data:res} = await this.$http.get(`/load/discount/use/shop/${id}`);
      this.selectedShops = res.data;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadDiscountTicket();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 100vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  width: 100%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 80%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/DiscountTickets.vue